module.exports = __webpack_public_path__ + "media/img/payment-methods/elo-469f0e0c8c900445db8610a5d25322e3.svg";